'use client';

import { ReactNode } from 'react';

import { SsrDataProvider } from '@api/data-loaders/resource';

type Props = {
  children: ReactNode;
  data: unknown;
};

export function SSRDataProvider({ children, data }: Props) {
  return <SsrDataProvider value={data}>{children}</SsrDataProvider>;
}
